<template>
  <header class="flex justify-center mt-20">
    <img
      src="@/assets/svg/logo.svg"
      class="site-header__image"
      @click="onClick" />
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { SECTION_IDS } from '@/util/enums'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState(['activeSectionId'])
  },
  methods: {
    onClick() {
      if(this.activeSectionId == SECTION_IDS.INTRO) {
        this.$store.commit('setActiveSectionId', SECTION_IDS.LOGO_WALL)
      } else {
        this.$store.commit('setActiveSectionId', SECTION_IDS.INTRO)
      }
    }
  }
}
</script>

<style lang="stylus">
.site-header
  &__image
    width 87px
    height 78px
</style>
